import { Button, FormField, Select } from '@cloudscape-design/components';
import { SelectProps } from '@cloudscape-design/components';
import './TagGroupSelector.css';

interface TagGroupSelectorProps {
  /** Available tag group options for the dropdown */
  options: SelectProps.Option[];
  /** Currently selected tag group name, or null when not grouping */
  selectedTagGroup: string | null;
  /** Callback when the selected tag group changes */
  onChange: (tagGroup: string | null) => void;
}

/**
 * TagGroupSelector - Dropdown to select a tag group for grouping audit questions.
 * Uses FormField with label on top, consistent with other filter controls.
 * Select stretches to fill width with an inline clear button.
 * Only renders when there are tag group options available.
 */
const TagGroupSelector = ({
  options,
  selectedTagGroup,
  onChange,
}: TagGroupSelectorProps) => {
  if (options.length === 0) return null;

  return (
    <FormField data-testid="group-by-container" label="Group by (Tag Group)">
      <div className="tag-group-selector-row">
        <div className="tag-group-selector-row__select">
          <Select
            data-testid="group-by-tag-select"
            selectedOption={
              selectedTagGroup
                ? {
                    label: selectedTagGroup,
                    value: selectedTagGroup,
                  }
                : null
            }
            onChange={({ detail }) => {
              onChange(detail.selectedOption?.value ?? null);
            }}
            options={options}
            placeholder="None"
            empty="No tag groups available"
          />
        </div>
        {selectedTagGroup && (
          <Button
            data-testid="clear-group-by-button"
            variant="icon"
            iconName="close"
            onClick={() => onChange(null)}
            ariaLabel="Clear grouping"
          />
        )}
      </div>
    </FormField>
  );
};

export default TagGroupSelector;
